import React from "react";
import Container from "react-bootstrap/Container";
import { Navbar, Nav, Button } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import finlandFlag from "./assets/images/fin.jpg";
import enFlag from "./assets/images/en.jpg";
import "bootstrap/dist/css/bootstrap.min.css";

import { useLanguage } from "./Context";

// Navigaation linkit molemmilla kielillä
const navItems = [
  { to: "/", fi: "Etusivu", en: "Home", end: true },
  { to: "/courses", fi: "Kurssit", en: "Courses" },
  { to: "/blogs", fi: "Blogi", en: "Blog" },
  { to: "/projektit", fi: "Projektit", en: "Projects" },
  { to: "/julkaisut", fi: "Julkaisut/Patentit", en: "Publications/Patents" },
];

function LanguageButton({ lang, flag, label, active, onClick }) {
  return (
    <Button
      variant={active ? "success" : "outline-secondary"}
      size="sm"
      onClick={() => onClick(lang)}
      aria-pressed={active}
      aria-label={label}
      className="d-flex align-items-center gap-1 px-2 py-1"
    >
      <img src={flag} alt="" style={{ width: 24, height: 16, display: "block" }} />
      <span className="small fw-semibold">{lang.toUpperCase()}</span>
    </Button>
  );
}

function NavBa() {
  const { language, changeLanguage } = useLanguage();
  const fi = language === "fi";

  return (
    <Navbar expand="lg" className="bg-body-tertiary" collapseOnSelect>
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <img
            src="/logo-nav.png"
            alt="Ville Majava"
            height="32"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        {/* Kielivalinta näkyy aina: mobiilissa hampurilaisvalikon vieressä,
            työpöydällä navigaation oikeassa reunassa */}
        <div className="d-flex align-items-center gap-2 ms-auto order-lg-last">
          <LanguageButton
            lang="fi"
            flag={finlandFlag}
            label="Suomi"
            active={fi}
            onClick={changeLanguage}
          />
          <LanguageButton
            lang="en"
            flag={enFlag}
            label="English"
            active={!fi}
            onClick={changeLanguage}
          />
          <Navbar.Toggle aria-controls="navbarScroll" className="ms-1" />
        </div>

        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0">
            {navItems.map((item) => (
              <Nav.Link
                key={item.to}
                as={NavLink}
                to={item.to}
                end={item.end}
                eventKey={item.to}
              >
                {fi ? item.fi : item.en}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default NavBa;
